import { Formik, Form, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { getStudentById } from '../../features/student/studentSlice';
import { useEffect, useState } from 'react';
import PersonIcon from '@mui/icons-material/Person';
import { Backdrop, Chip, CircularProgress, Typography } from '@mui/material';
import { getLabelsByInstituteType } from '../../utils/constants';
const ViewStudent = ({ StudentId }) => {
  const [studentData, setStudnetData] = useState('');
  let { instituteType } = useSelector((state) => {
    return state.auth?.successData?.userDetails ?? {};
  });
  let { Department, Class, Section } = getLabelsByInstituteType(instituteType);
  const dispatch = useDispatch();
  function guessMimeType(b64) {
    if (b64.startsWith('/9j/')) return 'image/jpeg';
    if (b64.startsWith('iVBORw0KGgo')) return 'image/png';
    return 'image/jpeg';
  }

  const ShadowImage = () => (
    <div className=' size-48  overflow-hidden rounded-md   flex items-center'>
      <PersonIcon className=' animate-pulse size-full text-gray-300 ' />
    </div>
  );
  async function getStudentData() {
    if (StudentId) {
      try {
        const data = await dispatch(getStudentById(StudentId)).unwrap();
        if (data) {
          let photo;
          if (data?.studentPhoto) {
            const mimeType = guessMimeType(data.studentPhoto);
            photo = `data:${mimeType};base64,${data.studentPhoto}`;
          }
          setStudnetData({
            ...data,
            studentPhoto: data?.studentPhoto ? photo : data?.studentPhoto,
          });
        } else {
          setStudnetData({});
        }
      } catch (error) {
        console.log(error);
        setStudnetData({});
      }
    }
  }

  useEffect(() => {
    getStudentData();
  }, [StudentId]);
  if (!StudentId)
    return (
      <div className='flex flex-col justify-center items-center h-60  rounded-lg'>
        <PersonIcon
          className='text-gray-300 mb-1 animate-pulse'
          style={{ fontSize: 90 }}
        />
        <Typography variant='h6' className='text-gray-400 mb-2'>
          No Student Selected
        </Typography>
        <Typography variant='body2' className='text-gray-500'>
          Please search by Student Id to know the student details.
        </Typography>
      </div>
    );
  return (
    <>
      <div className='w-full relative min-h-56 '>
        {!studentData && StudentId ? (
          <Backdrop
            open
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: (theme) => theme.zIndex.drawer + 1,
              width: '100%',
              height: '100%',
            }}
            className='bg-white'
          >
            <div>
              <div className='text-center'>
                <CircularProgress color='primary' />
              </div>
              <br />
              <div className='text-center '>
                Fetching Details.. of {StudentId}{' '}
              </div>
            </div>
          </Backdrop>
        ) : Object.keys(studentData)?.length > 0 ? (
          <Formik initialValues={studentData} enableReinitialize={true}>
            <Form>
              {/* student details with photo */}
              <div className='flex flex-col md:flex-row  gap-3 '>
                <div className=' md:w-2/3 flex flex-col  '>
                  <div className=' flex flex-col md:flex-row gap-x-3 '>
                    <div className='mb-2 md:w-1/2'>
                      <label htmlFor='studentId' className=' text-sm mb-[2px]'>
                        Student ID <Status status={studentData?.status} />
                      </label>
                      <Field
                        readOnly
                        type='text'
                        id='studentId'
                        name='studentId'
                        placeholder='STU0000'
                        className=' formik-input mt-0 bg-[#eaeefd] text-gray-500'
                      />
                    </div>
                    <div className='mb-2 md:w-1/2'>
                      <label htmlFor='studentRollNumber' className=' text-sm'>
                        Student Roll No
                      </label>
                      <Field
                        readOnly
                        type='number'
                        id='studentRollNumber'
                        name='studentRollNumber'
                        placeholder=''
                        className='formik-input bg-[#eaeefd] text-gray-500 '
                      />
                    </div>
                  </div>

                  <div className='flex flex-col md:flex-row gap-x-3'>
                    <div className='mb-2  md:w-1/2'>
                      <label htmlFor='firstName' className=' text-sm  '>
                        First Name
                      </label>
                      <Field
                        readOnly
                        type='text'
                        id='firstName'
                        name='firstName'
                        placeholder='Enter Last Name'
                        className='formik-input bg-[#eaeefd] text-gray-500 '
                      />
                    </div>
                    <div className='mb-2  md:w-1/2'>
                      <label htmlFor='lastName' className=' text-sm  '>
                        Last Name
                      </label>
                      <Field
                        readOnly
                        type='text'
                        id='lastName'
                        name='lastName'
                        placeholder='Enter Last Name'
                        className='formik-input bg-[#eaeefd] text-gray-500 '
                      />
                    </div>
                  </div>

                  <div className='flex flex-col md:flex-row gap-x-3 '>
                    <div className='  md:w-1/2'>
                      <label htmlFor='dateOfBirth' className=' text-sm  '>
                        Date Of Birth
                      </label>
                      <Field
                        readOnly
                        type='date'
                        id='dateOfBirth'
                        name='dateOfBirth'
                        placeholder='Enter  Number'
                        className='formik-input bg-[#eaeefd] text-gray-500 '
                      />
                    </div>
                    <div className='  md:w-1/2'>
                      <label htmlFor='gender' className='text-sm'>
                        Gender
                      </label>
                      <Field
                        readOnly
                        type='text'
                        id='gender'
                        name='gender'
                        className='formik-input bg-[#eaeefd] text-gray-500 '
                      />
                    </div>
                  </div>
                </div>

                <div className='md:w-1/3 flex flex-col '>
                  <label className=' text-sm'>Upload Photo</label>
                  <div className=' flex-1 rounded border-[1.5px] border-indigo-100 flex items-center justify-center mt-1 '>
                    <div className='   flex justify-center items-center '>
                      <>
                        <Field readOnly name='studentPhoto'>
                          {() => (
                            <div>
                              {studentData.studentPhoto ? (
                                <div className=' size-48  overflow-hidden rounded-md   flex items-center'>
                                  <img
                                    src={studentData.studentPhoto}
                                    alt={'no Photo'}
                                    className=' size-full min-h-fit max-h-fit  object-contain rounded-lg   p-1  '
                                  />
                                </div>
                              ) : (
                                <ShadowImage />
                              )}
                            </div>
                          )}
                        </Field>
                      </>
                    </div>
                  </div>
                </div>
              </div>
              {/* Communication Address */}
              <div className='grid grid-cols-1 md:grid-cols-3  gap-3 items-start mt-2'>
                <div>
                  <label htmlFor='mobileNumber' className=' text-sm  '>
                    Mobile Number
                  </label>
                  <Field
                    type='text'
                    id='mobileNumber'
                    name='mobileNumber'
                    placeholder='XXX-XXX-XXXX'
                    className='formik-input   bg-[#eaeefd] text-gray-500'
                  />
                </div>

                <div className='col-span-2'>
                  <label htmlFor='communicationAddress' className=' text-sm'>
                    Communication Address
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='communicationAddress'
                    name='communicationAddress'
                    placeholder='Enter Communicaiton Address'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
              </div>
              {/* Graduation Details */}

              <div className='grid grid-cols-1 md:grid-cols-3  gap-3 mt-2'>
                <div className='w-full  '>
                  <label htmlFor='guardian.relation' className='text-sm mb-1'>
                    Guardian Relation
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='guardian.relation'
                    name='guardian.relation'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                <div className='w-full '>
                  <label htmlFor='guardian.name' className=' text-sm  '>
                    Guardian Name
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='guardian.name'
                    name='guardian.name'
                    placeholder='Enter Guardian Name'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                <div className='w-full '>
                  <label htmlFor='guardian.contactNumber' className=' text-sm'>
                    Guardian Number
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='guardian.contactNumber'
                    name='guardian.contactNumber'
                    placeholder=''
                    className='formik-input bg-[#eaeefd] text-gray-500'
                  />
                </div>
              </div>

              {/* Department,class,section,fee,joining Date,Date of Leaving */}
              <div className='grid grid-cols-1 md:grid-cols-3  gap-3 items-end mt-2'>
                <div className='w-full'>
                  <label htmlFor='departmentName' className='text-sm'>
                    {Department} Name{' '}
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='departmentName'
                    name='departmentName'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                <div className='w-full '>
                  <label htmlFor='className' className='text-sm'>
                    {Class} Name{' '}
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='className'
                    name='className'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                {instituteType.toLowerCase() === 'college' && (
                  <div className='w-full '>
                    <label htmlFor='sectionName' className='text-sm'>
                      {Section}
                    </label>
                    <Field
                      readOnly
                      type='text'
                      id='sectionName'
                      name='sectionName'
                      className='formik-input bg-[#eaeefd] text-gray-500 '
                    />
                  </div>
                )}
                <div className='w-full'>
                  <label htmlFor='totalFees' className=' text-sm  '>
                    Total Fee
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='totalFees'
                    name='totalFees'
                    placeholder='₹0.00'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                <div className='w-full'>
                  <label htmlFor='dateOfJoining' className=' text-sm'>
                    Date Of Joining
                  </label>
                  <Field
                    readOnly
                    type='date'
                    id='dateOfJoining'
                    name='dateOfJoining'
                    placeholder=''
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
                <div className='w-full '>
                  <label htmlFor='dateOfLeaving' className=' text-sm'>
                    Date Of Leaving{' '}
                    <span className=' text-lg text-red-800 '> </span>
                  </label>
                  <Field
                    readOnly
                    type='date'
                    id='dateOfLeaving'
                    name='dateOfLeaving'
                    placeholder='Enter  Number'
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
              </div>
              {/* Remarks */}
              <div className='grid grid-cols-1 md:grid-cols-3  gap-3 items-start mt-2'>
                <div className='col-span-2'>
                  <label htmlFor='remarks' className=' text-sm'>
                    Remarks
                  </label>
                  <Field
                    readOnly
                    type='text'
                    id='remarks'
                    name='remarks'
                    placeholder='No Remarks '
                    className='formik-input bg-[#eaeefd] text-gray-500 '
                  />
                </div>
              </div>
            </Form>
          </Formik>
        ) : (
          <div className='flex items-center justify-center  rounded-lg h-56  '>
            <Typography variant='body1'>
              No student details found for <b>{StudentId}</b>
            </Typography>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewStudent;
const Status = ({ status = '' }) => {
  if (status === 'ACTIVE')
    return <Chip className='h-6' label='Active' color='success' />;
  else if (status === 'INACTIVE')
    return <Chip label='InActive' color='warning' />;
  else if (status === 'DELETED') return <Chip label='Deleted' color='error' />;
  else if (status === 'DROPPED_OUT')
    return <Chip label='Dropped Out' color='error' />;
  else if (status === 'PASSED_OUT')
    return <Chip label='Passed Out' color='primary' />;
  else return <Chip label='NoStatus' />;
};
